import React, {PureComponent} from "react";
import {ContentSizeContext} from "./ResponsiveContent";

export default (View) => class SizeExtractor extends PureComponent {
  render() {
    return (
      <ContentSizeContext.Consumer>
        {contentSize => <View contentSize={contentSize} {...this.props} />}
      </ContentSizeContext.Consumer>
    );
  }
};
